import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { date, FormattedStreamValue, getShape, isNone, ShapeName } from '@squaredup/data-streams';
import LoadingSpinner from 'components/LoadingSpinner';
import { TruncatedText } from 'components/TruncatedText';

export const FormattedValue = ({
    sampleValue,
    shapeName,
    isLoading
}: {
    sampleValue: FormattedStreamValue;
    shapeName: ShapeName;
    isLoading?: boolean;
}) => {
    if (isLoading) {
        return (
            <div className='flex items-center mt-1'>
                <LoadingSpinner size={16} />
            </div>
        );
    }

    if (isNone(sampleValue.value)) {
        const shape = getShape(shapeName);
        const shapeMessage = shape != null ? ` to ${shape.displayName}` : '';

        const actionMessage =
            shape === date
                ? 'Set Input Format to match the raw values or choose a different shape.'
                : 'Try a different shape.';

        return (
            <div className='flex items-center gap-4 '>
                <FontAwesomeIcon icon={faTriangleExclamation} className='cursor-pointer text-statusWarningPrimary' />

                <span className='text-sm leading-tight'>
                    {`Failed to convert${shapeMessage}`}
                    <br />
                    {actionMessage}
                </span>
            </div>
        );
    }

    return <TruncatedText title={sampleValue.formatted?.toString() ?? ''}>{sampleValue.formatted}</TruncatedText>;
};
